/**
 * Firebase event logging for KYC journeys.
 */

import {logEvent} from 'firebase/analytics';

import {getKycTypeEventValue, shouldLogKycFirebaseEvent} from 'constants/kycFirebaseEvents';

import {getAnalyticsUserId} from './analyticsUserId';
import {analyticsPromise} from './firebase';

const logFirebaseEvent = async (eventName, eventParams = {}) => {
  if (typeof window === 'undefined') {
    return;
  }

  //TODO: Remove after testing
  console.log(eventName, eventParams);

  const analytics = await analyticsPromise;

  if (analytics) {
    logEvent(analytics, eventName, {
      ...eventParams,
      debug_mode: process.env.NODE_ENV === 'development',
    });
  }
};

export const logKycFirebaseEvent = (flow, eventName, params = {}) => {
  if (!shouldLogKycFirebaseEvent(flow)) {
    return;
  }

  const userKey = getAnalyticsUserId();

  logFirebaseEvent(eventName, {
    flow,
    kycType: getKycTypeEventValue(flow),
    timestamp: new Date().toISOString(),
    ...(userKey ? {user_key: userKey} : {}),
    ...params,
  });
};

export default logFirebaseEvent;
